export async function sendContactMessage(formData) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);

  try {
    const response = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
      signal: controller.signal,
    });
    const data = await response.json().catch(() => null);

    if (response.ok && data?.success === true) return;

    if (response.status === 422 || response.status === 429) {
      throw new Error(data?.error || data?.detail || 'Vérifiez les champs ou réessayez dans une minute.');
    }
    throw new Error("Le service d'envoi est momentanément indisponible. Réessayez plus tard ou contactez-moi directement par email.");
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error("Le serveur met trop de temps à répondre. L'envoi n'a pas pu être confirmé. Contactez-moi directement par email si nécessaire.");
    }
    if (error instanceof TypeError) {
      throw new Error("Impossible de joindre le service d'envoi. Réessayez ou contactez-moi directement par email.");
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
}
